// extracted by mini-css-extract-plugin
export default {"emailKindCellRoot":"EmailKindCell_emailKindCellRoot__5kHj0","label":"EmailKindCell_label__1QkWh","icon":"EmailKindCell_icon__61MGr"};